export default "__VITE_ASSET__CzOtltEX__"